<script>
  export default {
    props: {
      tableData: Object,
      customRenderers: Array,
      searchField: String
    },
    data () {
      return {
        paginationEventValue: {
          itemsLength: 0,
          itemsPerPage: 0,
          page: 0
        },
        item: [],
        singleSelect: false,
        selected: [],
        startSearchKeyLength: 3,
        totalItemFromApi: 0,
        itemCollectionFromApi: [],
        apiReturn: [],
        loading: true,
        headers: [],
        options: {
          itemsPerPage: 10
        },
        query: {
          page: 1,
          itemsPerPage: 10,
          q: ""
        }
      }
    },
    beforeMount(){
      this.requestAjaxTableData()
    },
    mounted(){

    },
    computed: {
      getItems() {
        return this.$store.getters[this.tableData.getters];
      }
    },
    watch: {
      getItems(newVal) {
        this.query.q = this.searchField
        this.apiReturn = newVal
        try {
          if (this.apiReturn.results.length > 0) {
            this.getDataFromApi()
          }
        } catch (error) {
          console.log('%c Mapping of API from endpoint is not matching the Front end parser', 'background: #FF0000; color: #bada55');
          // console.log(error)
          return false;
        }
      },
    
      options: {
        handler () {
          this.loading = true
          this.getDataFromApi()
        },
        deep: true,
      },
      
    },
    methods: {
      paginationEvent(pagination) {
        this.loading = true
        this.paginationEventValue = pagination
        this.query.page = this.paginationEventValue.page
        this.query.itemsPerPage = this.paginationEventValue.itemsPerPage
        this.requestAjaxTableData()
        this.getDataFromApi()
        // this.loading = false
      },
      requestAjaxTableData(parameter = ''){
        this.headers = this.tableData.headers
        
        if (parameter != ''){
          this.query.q = parameter
        }
        if(this.tableData.hasOwnProperty('gettersPage')){
          let pageStoredData = this.$store.getters[this.tableData.gettersPage]
          if(pageStoredData.page > 1){
            this.query['page'] = pageStoredData.page
            this.query['itemsPerPage'] = pageStoredData.itemsPerPage
            this.options.itemsPerPage = pageStoredData.itemsPerPage
          } 
        }
        if(this.tableData.hasOwnProperty('settersPage')){
          this.$store.commit(this.tableData.settersPage,  this.query);
        }
        this.$store.dispatch(this.tableData.dispatchFunction)
        this.$store.commit(this.tableData.settersItem, null)
      },
      
      getDataFromApi () {
        this.scrollToTop()
        this.loading = true
        this.dataTableParsing().then(data => {
          this.itemCollectionFromApi = data.items
        })
      },
      dataTableParsing () {
        return new Promise((resolve, reject) => {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          if(this.apiReturn.length != 0){
            let items = this.apiReturn.results
            this.totalItemFromApi = this.apiReturn.count
            const total = items.length

            if (sortBy.length === 1 && sortDesc.length === 1) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy[0]]
                const sortB = b[sortBy[0]]
                if (sortDesc[0]) {
                  if (sortA < sortB) return 1
                  if (sortA > sortB) return -1
                  return 0
                } else {
                  if (sortA < sortB) return -1
                  if (sortA > sortB) return 1
                  return 0
                }
              })
            }

            setTimeout(() => {
              resolve({
                items,
                total,
              })
              this.loading = false
            }, 1000)
           }else{
             this.loading = false
           }
        })
      },
      // COMMON FUNCTION HERE
      emitSelectedItem(vale) {
        let selectCollection = this.selected
        this.$emit("datatableSelectedItem", selectCollection);
      },
      scrollToTop() {
        window.scrollTo(0,0);
      }
    },
  }
</script>

<template>
  <div>
    <v-data-table @pagination="paginationEvent" @input="emitSelectedItem()" 
        v-model="selected"
        :single-select="singleSelect"
        item-key="id"
        show-select
        :footer-props="{'items-per-page-options':[10, 50, 100]}"
        :headers="headers"
        :items="itemCollectionFromApi"
        :server-items-length="totalItemFromApi" 
        :options.sync="options"
        :loading="loading"
        :page="query.page"
        class="elevation-1"
        loading-text="Loading... Please wait"
        no-data-text="No data available"
    >
      <template v-slot:loading>
        <slot name="customeLoading">
              <v-progress-circular
              indeterminate
              color="primary"
              ></v-progress-circular>
        </slot> 
      </template>
      <template v-for="slot in this.customRenderers" v-slot:[`item.${slot.field}`]="{ item }">
        <slot v-bind:item="item" :name="`${slot.field}params`"> </slot>
      </template>
    </v-data-table>
  </div>
</template>
